import { useState, SyntheticEvent, SetStateAction, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import { ComplaintContainer } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import { TabWithCount } from "../SocialCase/SocialCase";
import Tab from "@mui/material/Tab";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import ApplyPropertyDetails from "../../components/ApplyForNOCTabs/PropertyDetailsTab";
import FeesAndChargesNOC from "../../components/ApplyForNOCTabs/FeesAndCharges";
import nocsRequestsStore, {
  ChargesResult,
} from "../../stores/NocsRequestsStore";
import generalStore from "../../stores/GeneralStore";
import CardsPopup from "../../components/MoveOutTerminationTabs/CardsPopup";
import CardsStore from "../../stores/CardsStore";
import { useLocation } from "react-router-dom";
import axios from "axios";
import CONSTANTS from "../../utils/constants";
import { ToastContainer } from "react-toastify";
import { Modal} from "@mui/material";

import General from '../../stores/GeneralStore'
import { observer } from "mobx-react";
import Thankyou from "../../components/SocialCaseTbas/Thankyou";
import moveInOutStore from "../../stores/MoveInOutStore";
import { NotifyError } from "../../utils/ShowError";
import './applynoc.scss'
import { NotifySuccess } from "../../utils/ShowSuccess";
import User from "../../stores/UserStore";
import { toJS } from "mobx";
import { GatewaySelection } from "../../components/MoveOutTerminationTabs/GatewaySelection";
import { ACTIVE_PAYMENT_GATEWAY } from "../../utils/constants";
const dummy_charge = {
  amount: "",
  count: "",
};

interface Obj {
  [key: string]: any;
}

interface AppConfig {
  "isCheckout" : boolean
}

const ApplyForNOCInside = () => {
  const tenantExist = localStorage.getItem("nocType");
  const location = useLocation();
  const { id } = useParams();
  var login
  if (!id) { login = location?.state?.login }

  const [value, setValue] = useState(0);

  const [Noc, setNoc] = useState<any>(login ? "Outside" : "Inside");

  const [parcelNumber, setParcelNumber] = useState<string>("");
  const [nocTypeSelected, setNocTypeSelected] = useState<string>(!login ? (tenantExist != "ownernoc" && tenantExist != 'tenantnoc') ? "parcel" : "" : "plotNOC");
  const [caseId, setCaseId] = useState<any>()
  const [isTenantExist, setTenantExist] = useState<any>('');
  const [paymentModal, setPaymentModal] = useState(true);

  const [nocOutSideDues, setNocOutSideDues] = useState<any>({
    tenantFee: '',
    connectionFees: '',
    serviceFees: '',
    nOCCharges: '',
    customerName: null,
  })
  const [outSideNOCData, setOutSideNOCData] = useState<any>()
  const [postNOCDue, setPostNOCDue] = useState<Obj>({});
  const [postNOCDuePropertyCount, setPostNOCDuePropertyCount,] = useState<any>({
    nOCPropertyCount: '',
    connecservicePropertyCounttionFees: '',
    connectionPropertyCount: '',
    tenantPropertyCount: '',
  });
  const [fewaValue, setFewaValue] = useState<boolean>(false);
  const [tenancyContractExpiryDate, setTenancyContractExpiryDate] = useState<string>("");
  const [serviceId, setServiceId] = useState<any>(null);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

const handleGetCardsList = async () => {
  await CardsStore.getCardsList({ errorId: "getCardsListError" });
  };
   useEffect(() => {
    handleGetCardsList();
   },[])
   
  const NOCTypes = {
    parcel: 1,
    owner: 2,
    tenant: 3,
    plotNOC: 5,
    arra: 6,
    tenantOut: 7,
  } as any;

  const [paymentLoader, setPaymentLoader] = useState(false);
  const isCheckoutActive = ACTIVE_PAYMENT_GATEWAY === 'CHECKOUT';
  
   const [config, setConfig] = useState<AppConfig | null>(null);

    useEffect(() => {
        async function loadConfig() {
          try {
            const response = await fetch('/config/config.json'); 
            const json = await response.json();
            setConfig(json);
          } catch (err) {
            console.error("Error loading config:", err);
          }
        }
        loadConfig();
      }, []);

  const handleNOCPayment = async (cardData: any) => {
    setPaymentLoader(true)

    const getNocType = (nocType: string) => {
      const typeMap: { [key: string]: any } = {
        parcel: NOCTypes.parcel,
        owner: NOCTypes.owner,
        tenant: NOCTypes.tenant,
        OUTP: NOCTypes.plotNOC,
        OUTO: NOCTypes.arra,
        OUTT: NOCTypes.tenantOut
      };

      return typeMap[nocType];
    };


    const data = {
      ...cardData,
      nocTypeSelected: nocTypeSelected,
      nocRefID: postNOCDue.nocRefID,
      amount: postNOCDue.totalDue,
      fewaRegistrationFlag: fewaValue, //TODO conditions to 7atta false / true
      nocAppliedNo: parcelNumber,
      email: outSideNOCData?.emailAddress,
      nocType: getNocType(outSideNOCData?.nocType),
      caseId: caseId?caseId: id,
      tenancyContractExpiryDate
    };

    if (Noc == "Inside") {
      const responseee = await nocsRequestsStore.makeNOCPayment({
        errorId: "makeNOCPaymentError",
        data,
      });
      if (responseee?.message == "Success") {
        window.open(responseee?.result?.redirectUrl, '_self')
      }
    }
    else if (Noc == "Outside") {
      const res: any = nocsRequestsStore.makeNOCOutsidePayment({
        errorId: "makeNOCOutsidePaymentError",
        data,
      });
      if (res?.message == "Success") {
        window.open(res?.result?.redirectUrl, '_self')
      }
    }
  };
  const getCurrentLAn = () => {
        if (General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "ARA") return "ar";
        if (General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "HIN") return "hi";
        return "en";
    };

    const getNocType = (nocType: string) => {
        const typeMap: { [key: string]: any } = {
            parcel: NOCTypes.parcel,
            owner: NOCTypes.owner,
            tenant: NOCTypes.tenant,
            OUTP: NOCTypes.plotNOC,
            OUTO: NOCTypes.arra,
            OUTT: NOCTypes.tenantOut
        };
        return typeMap[nocType] || nocType;
    };
    
    const buildNOCPaymentData = () => {
        const isOutOfNetworkFlow = !!id; 
        const currentLAn = getCurrentLAn();

        let baseData;
        let amountToPay;

        if (isOutOfNetworkFlow) {
            amountToPay = outSideNOCData?.paymentAmount;
            baseData = {
                nocTypeSelected: outSideNOCData?.nocType,
                nocRefID: outSideNOCData?.transactionRefId,
                nocAppliedNo: outSideNOCData?.parcelNumber,
                tenancyContractExpiryDate: "",
                nocType: getNocType(outSideNOCData?.nocType),

            };
        } else {
            amountToPay = postNOCDue.totalDue;
            baseData = {
                nocTypeSelected: nocTypeSelected,
                nocRefID: postNOCDue.nocRefID,
                nocAppliedNo: parcelNumber,
                tenancyContractExpiryDate: tenancyContractExpiryDate,
                nocType: getNocType(nocTypeSelected)
            };
        }
        
        return {
            amount: amountToPay, 
            ...baseData,
            fewaRegistrationFlag: fewaValue,             
            caseId: caseId ? caseId : id,
            type: `${currentLAn}-Payments-Web`,
            token:"",
            customerAddress:null,
            returnUrl: `${window.location.origin}/Payment/ExternalRedirect`, 
            personId: User?.profile?.personId,
            paymentRequestType: 1,
        };
    };

  const handlePaymentInitiation = async (payload: any, gatewayType: string) => {
    const isOutOfNetworkFlow = !!id;
    if (gatewayType === "tabby") {
      if (!User?.profile?.personId) {
        let eligibledata = { amount: payload.amount, mobile: payload.mobile, email: payload.email, }
        const eligibilityResponse = await nocsRequestsStore.makeTabbyEligibilityCheck({
          errorId: "tabbyEligibilityCheckError",
          data: eligibledata,
        });
        if (!eligibilityResponse?.result?.isEligible) {
          throw new Error(eligibilityResponse?.result?.message || "Tabby payment is currently not eligible.");
        }
      }
      if (isOutOfNetworkFlow || Noc === "Outside") {
        const responseee = await nocsRequestsStore.makeTabbyNOCOutsidePayment({
          errorId: "makeNOCTabbyOutsidePaymentError",
          data: payload,
        });
        if (responseee?.message === "Success") return responseee;
        throw new Error(responseee?.message || "Outside NOC Tabby Payment initiation failed.");
      }

      if (Noc === "Inside") {
        const responseee = await nocsRequestsStore.makeTabbyNOCPayment({
          errorId: "makeNOCTabbyPaymentError",
          data: payload,
        });
        if (responseee?.message === "Success") return responseee;
        throw new Error(responseee?.message || "Inside NOC Tabby Payment initiation failed.");
      }
    }
    if (gatewayType === "ni") {
      if (isOutOfNetworkFlow || Noc === "Outside") {
        const responseee = await nocsRequestsStore.makeNINOCOutsidePayment({
          errorId: "makeNOCOutsidePaymentError",
          data: payload,
        });
        if (responseee?.message === "Success") return responseee;
        throw new Error(responseee?.message || "Outside NOC Payment initiation failed.");
      }
      if (Noc === "Inside") {
        const responseee = await nocsRequestsStore.makeNINOCPayment({
          errorId: "makeNOCPaymentError",
          data: payload,
        });
        if (responseee?.message === "Success") return responseee;
        throw new Error(responseee?.message || "Inside NOC Payment initiation failed.");
      }
    }
    if (gatewayType === "tamara") {
      if (isOutOfNetworkFlow || Noc === "Outside") {
        const responseee = await nocsRequestsStore.makeTamaraNOCOutsidePayment({
          errorId: "makeNOCOutsidePaymentError",
          data: payload,
        });
        if (responseee?.message === "Success") return responseee;
        throw new Error(responseee?.message || "Outside NOC Payment initiation failed.");
      }
      if (Noc === "Inside") {
        const responseee = await nocsRequestsStore.makeTamaraNOCPayment({
          errorId: "makeNOCPaymentError",
          data: payload,
        });
        if (responseee?.message === "Success") return responseee;
        throw new Error(responseee?.message || "Inside NOC Payment initiation failed.");
      }
    }

    throw new Error("Invalid NOC payment context.");
  };

  const checkTabbyEligibility = async (payload: any) => {
  try {
    const response = await nocsRequestsStore.makeTabbyEligibilityCheck({
            errorId: "tabbyEligibilityCheckError",
            data: payload,
          });
    // return !!response?.result?.isEligible;
    const isEligible = !!response?.result?.isEligible;
    const message = response?.result?.message || "";
const isAmountEligible = response?.result?.isAmountEligible;

    return { isEligible, message, isAmountEligible };
  } catch (error) {
    console.error("Eligibility check failed:", error);
    return false;
  }
};

const checkTamaraEligibility = async (payload: any) => {
  try {
    const response = await nocsRequestsStore.makeTamaraEligibilityCheck({
            errorId: "tamaraEligibilityCheckError",
            data: payload,
          });
    const message = response?.result?.message || "";
const isAmountEligible = response?.result?.isAmountEligible;

    return {message, isAmountEligible };
  } catch (error) {
    console.error("Tamara eligibility check failed:", error);
    return false;
  }
};


  const handlePayment3Ds = async (code: any) => {

    const response = await moveInOutStore.payment3Ds(code);
    let paymentId = response.result.paymentId;
    let successMessage = "Thank you. Your payment has been successfully processed.<br> Payment ID:"
    successMessage = successMessage + paymentId
    alert(successMessage);

  }
  useEffect(() => {
    if (window.location.href.includes("cko-session-id=")) {
      let locationUrl = window.location.href;
      let code = locationUrl.split("cko-session-id=")[1];
      handlePayment3Ds(code);
    }
  }, [])
  const [isCaseId, setIsCaseId] = useState(true);
const [dueLoader, setDueLoader] = useState(false);

  const handleOutofNetworkDues = async () => {
    setDueLoader(true)
    const newCaseId:any=id;
    localStorage.setItem("isCaseId", newCaseId);
    const res = await nocsRequestsStore.getOutOfNetworkNOCBalanceTest({
      errorId: "getOutOfNetworkNOCBalanceError",
      data: { platform: "web", caseId: id },
    });
    if (res?.result?.caseId == null || res?.result?.summary == null) {
      setDueLoader(false)
      const labelString = res?.result?.message.toLowerCase()?.split("|")[0];
      if (labelString == "msg_92000_1308") {
        const message = General?.codeLabels[`cm_${labelString}`]?.label
          ? General?.codeLabels[`cm_${labelString}`]?.label
          : "Out of Network NOC request has been cancelled as the payment has not been received";
        NotifyError(message);
      } else if (labelString == "msg_92000_6012") {
        NotifySuccess(
          General?.codeLabels[`cm_${labelString}`]?.label
            ? General?.codeLabels[`cm_${labelString}`]?.label
            : "Out of Network NOC request has been cancelled as the payment has not been received"
        );
      } else {
        NotifyError(General?.codeLabels[`cm_${labelString}`]?.label);
      }

      setIsCaseId(false);
      return;
    }
    setOutSideNOCData(res?.result);
    setDueLoader(false)
    const data = res?.result?.summary;
    if (data.length > 0) {
      // Find the object with chargeType "UOS" and get the totalAmount
      const tenantFee = data.find(
        (obj: any) => obj.chargeType === "UOS"
      );
      const tenantFeeAmount = tenantFee ? tenantFee.totalAmount : 0;
      const tenantPropertyCount = tenantFee ? tenantFee.propertyCount : 0;

      // Find the object with chargeType === "DEFAULT" and get the totalAmount
      const serviceFees = data.find(
        (obj: any) => obj.chargeType === "DEFAULT"
      );
      const serviceFeesAmount = serviceFees ? serviceFees.totalAmount : 0;
      const servicePropertyCount = serviceFees ? serviceFees.propertyCount : 0;

      // Find the object with chargeType === "CONNECTOR" and get the totalAmount
      const connectionFees = data.find(
        (obj: any) => obj.chargeType === "CONNECTOR"
      );
      const connectionFeesAmount = connectionFees ? connectionFees.totalAmount : 0;
      const connectionPropertyCount = connectionFees ? connectionFees.propertyCount : 0;

      // Find the object with chargeType === "NOC" and get the totalAmount
      const nOCCharges = data.find(
        (obj: any) => obj.chargeType === "NOC"
      );
      const nOCChargesAmount = nOCCharges ? nOCCharges.totalAmount : 0;
      const nOCPropertyCount = nOCCharges ? nOCCharges.propertyCount : 0;
      // Update the state with the obtained amounts
      setNocOutSideDues({
        tenantFee: tenantFeeAmount,
        connectionFees: connectionFeesAmount,
        serviceFees: serviceFeesAmount,
        nOCCharges: nOCChargesAmount,
        customerName: res?.result?.customerName ? res?.result?.customerName : null
      });
      setPostNOCDuePropertyCount({
        tenantPropertyCount,
        connectionPropertyCount,
        servicePropertyCount,
        nOCPropertyCount,
      });
    } else {
      // No objects in the response array, set all amounts to 0
      setNocOutSideDues({
        tenantFee: 0,
        connectionFees: 0,
        serviceFees: 0,
        nOCCharges: 0,
        customerName: null,
      });
    }
  };
  console.log(postNOCDuePropertyCount)
  const handlePaymentOutOfNetwork = async (cardData: any) => {
    setPaymentLoader(true)

    const getNocType = (nocType: string) => {
      const typeMap: { [key: string]: any } = {
        parcel: NOCTypes.parcel,
        owner: NOCTypes.owner,
        tenant: NOCTypes.tenant,
        OUTP: NOCTypes.plotNOC,
        OUTO: NOCTypes.arra,
        OUTT: NOCTypes.tenantOut
      };

      return typeMap[nocType];
    };

    const data = {
      ...cardData,
      nocTypeSelected: outSideNOCData?.nocType,
      nocRefID: outSideNOCData?.transactionRefId,
      amount: outSideNOCData?.paymentAmount,
      email: outSideNOCData?.emailAddress,
      nocType: getNocType(outSideNOCData?.nocType),
      fewaRegistrationFlag: fewaValue, //TODO conditions to 7atta false / true
      nocAppliedNo: outSideNOCData?.parcelNumber, //sewerage number
      caseId:caseId?caseId: id,
    };
    const res: any = await nocsRequestsStore.makeNOCOutsidePayment({
      errorId: "makeNOCOutsidePaymentError",
      data,
    });
    if (res?.message === "Success") {
      window.open(res?.result?.redirectUrl, '_self')
    }

  }

  useEffect(() => {

    if (id) {
      handleOutofNetworkDues();
      setValue(1);
      setNoc("Outside")
    }

    if (tenantExist == "ownernoc" || tenantExist == "tenantnoc") {
      setTenantExist(tenantExist);
    }
    const hashLoc = location.hash;
    if (hashLoc) {
      const hashValue = hashLoc.substring(1);
      setTenantExist(hashValue);
    }
  }, []);
  useEffect(() => {
  const fetchServices = async () => {
    if (!User?.info?.personId) return;

    await User?.getServesis();

    const serviceId = User?.servesis?.find(
      (element: any) =>
        element?.serviceGuidePageLink?.toLowerCase() === "tenantnoc"
    )?.serviceGuideId;

    if (serviceId) {
      generalStore.incrementServiceUsage(serviceId);
    }
  };

  fetchServices();
}, []);

  useEffect(() => {
    handleGetToken();
  }, []);

  const handleGetToken = async () => {
    const data = {
      clientId: "ajman-sewerage",
      secret: "33cdc4b5a0e94c6f905b58e66931905d",
    };

    axios.post(CONSTANTS.URL.FETCH_TOKEN, data).then(function (response) {
      const sds = response.data.result.token;
      localStorage.setItem("serviceToken", sds);
    });
  };
  const navigate = useNavigate()
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div style={{ backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : '' }}>
      {/* <ToastContainer /> */}

      <MoveInHeader
        style={{
          background: contrast?.contrastBackground ? contrast?.contrastBackground : "#62aa51",
          color: contrast?.contrastColor ? contrast?.contrastColor : "",
          padding: User?.profile?.personId ? General?.isLargeScreen ? General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "1.2rem 5rem 1.2rem 4rem" : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "1.2rem 5rem 1.2rem 4rem" : "1.2rem 0rem 1.2rem 4rem" : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "6rem 1rem 1.2rem 1rem" : "6rem 0rem 1.2rem 1rem" : General?.isLargeScreen ? "1.2rem 5rem 1.2rem 4rem" : "8rem 1rem 1.2rem 1rem",
        }}

      >
        <div>
          {!login && "Outside" && (
            <MiniNav>
              <ButtonSecondary
                style={{
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : 'rgba(98, 170, 81, 1)',
                  fontSize: `${General.accessibility.fontSize}rem`,
                  width: "81px",
                  height: "30px",
                  border: "1px solid #FFF",
                  zIndex: "0",
                }}
                onClick={() => navigate('/dashboard')}
              >

                {generalStore?.codeLabels["cm_backbutton"]?.label !== undefined ? generalStore?.codeLabels["cm_backbutton"]?.label : "Back"}
              </ButtonSecondary>
              {User?.info?.personId && <ButtonSecondary
                style={{
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : 'rgba(98, 170, 81, 1)',
                  fontSize: `${General.accessibility.fontSize}rem`,
                  width: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "12rem" : "117px",
                  height: "30px",
                  border: "1px solid #FFF",
                  zIndex: "0",
                }}
                onClick={() => navigate('/dashboard')}
              >

                {generalStore?.codeLabels["cm_dashboard"]?.label !== undefined ? generalStore?.codeLabels["cm_dashboard"]?.label : "DASHBOARD"}

              </ButtonSecondary>}
            </MiniNav>
          )}
          <h1
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: General?.isLargeScreen ? `${3.1 * General.accessibility.fontSize}rem` : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
          >
            {Noc == "Outside" ? General?.codeLabels["cm_nocoutsidetitle"]?.label : General?.codeLabels['cm_nocinsidetitle']?.label}
          </h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer
        style={{
          backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : '#fff',
          width: General?.isLargeScreen ? "" : "100%",
          marginTop: (General?.isLargeScreen&&value==3) ?  "1rem" : "0rem",
        }}>
        <Box
          sx={{
            width: General?.isLargeScreen ?  `${value==3?"100%": "80%"}` : "100%",
            paddingTop:value==3?"0rem": "1rem",
          }}
        >
          {value != 3 && <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: General?.isLargeScreen ? '' : "center"
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{ alignSelf: "flex-end", width: { md: '70%', lg: '100%' }, zIndex: '0' }}
              variant="scrollable"
              // scrollButtons
              allowScrollButtonsMobile
            >
              {/* <Tab
                label={
                  <TabWithCount  value={value} count={1}>
                  {General?.isLargeScreen&&<span className="InsideNocText" style={{  fontSize:`${0.88*General.accessibility.fontSize}rem`}}>
                  {generalStore?.codeLabels["cm_propertydet"]?.label !== undefined ? generalStore?.codeLabels["cm_propertydet"]?.label : "Property Details"}
                  </span>}
                  </TabWithCount>
                }
                className="mui-move-in"
                {...a11yProps(0)}
                sx={{
                  background:General?.isLargeScreen? contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#e7e9f8":"",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  zIndex: "0",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={id?true:false}
              /> */}
              <Tab
                label={
                  <TabWithCount value={value} count={1}>
                    {General?.isLargeScreen &&
                      <span
                        style={{
                          fontSize: `${0.88 * General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor ? contrast?.contrastBackground : ColorAss,
                        }}>
                        {generalStore?.codeLabels["cm_propertydet"]?.label !== undefined ? generalStore?.codeLabels["cm_propertydet"]?.label : "Property Details"}
                      </span>}
                  </TabWithCount>
                }
                className="mui-move-in"
                {...a11yProps(0)}
                sx={{
                  background: General?.isLargeScreen ? contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#e7e9f8" : "",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  zIndex: "0",
                  alignItems: "start",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={id ? true : false}
              />
              {!login && (
                <Tab
                  label={
                    <TabWithCount value={value} count={2}>
                      {General?.isLargeScreen && <span style={{ fontSize: `${0.88 * General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastBackground : ColorAss, }}>{generalStore?.codeLabels["cm_fees_charges"]?.label !== undefined ? generalStore?.codeLabels["cm_fees_charges"]?.label : "Fees & Charges"}</span>}
                    </TabWithCount>
                  }
                  className="mui-move-in"
                  {...a11yProps(1)}
                  sx={{
                    background: General?.isLargeScreen ? contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#e7e9f8" : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={value == 2 ? false : true}
                />
              )}

              {!login && (
                <Tab
                  label={
                    <TabWithCount value={value} count={3}>
                      {General?.isLargeScreen && <span style={{ fontSize: `${0.88 * General.accessibility.fontSize}rem`, color: contrast?.contrastColor ? contrast?.contrastBackground : ColorAss, }}>
                        {generalStore?.codeLabels["cm_payments"]?.label !== undefined ? generalStore?.codeLabels["cm_payments"]?.label : "Payments"}
                      </span>}
                    </TabWithCount>
                  }
                  className="mui-move-in"
                  {...a11yProps(2)}
                  sx={{
                    background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    width: "32.5%",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={value == 3 ? false : true}
                />
              )}
            </Tabs>
          </Box>}

          <TabPanel value={value} index={0}>
            <ApplyPropertyDetails
              setParentParcelNumber={(pNumber) => setParcelNumber(pNumber)}
              setParentNocTypeSelected={(nocType) =>
                setNocTypeSelected(nocType)
              }
              onClick={() => setValue(value + 1)}
              insideHead={() => setNoc("Inside")}
              outside={() => setNoc("Outside")}
              fromLogin={login}
              setPostNOCDue={(e: SetStateAction<ChargesResult>) =>
                setPostNOCDue(e)
              }
              setValue={(e: SetStateAction<number>) =>
                setValue(e)
              }
              setCaseId={(e: SetStateAction<string>) =>
                setCaseId(e)
              }
              setFewaValue={(e: SetStateAction<boolean>) => setFewaValue(e)}
              isTenantExist={isTenantExist}
              setTenancyContractExpiryDate={setTenancyContractExpiryDate}
              setServiceId={(e: SetStateAction<any>) => setServiceId(e)}
            />
          </TabPanel>
          {!login && isCaseId && (
            <TabPanel value={value} index={1}>
              <FeesAndChargesNOC
                Previous={() => setValue(value - 1)}
                serviceCharges={postNOCDue?.serviceCharges}
                tenantFeeDues={postNOCDue?.tenantFeeDues}
                nocCharge={id ? nocOutSideDues : postNOCDue?.nocCharge}
                deliveryCharge={postNOCDue?.deliveryCharge}
                isId={id ? true : false}
                connectionFees={postNOCDue?.connectionFees}
                onClick={() => setValue(value + 1)}
                postNOCDuePropertyCount={postNOCDuePropertyCount}
                duesLoader={dueLoader}
              />
            </TabPanel>
          )}
          {!login && (
            <TabPanel value={value} index={2}>
              {/* {config?.isCheckout ?(
                <CardsPopup
                makePayment={id ? handlePaymentOutOfNetwork : handleNOCPayment}
                fromAutoPay={false}
                paymentLoader={paymentLoader}
                amount={id ? outSideNOCData?.paymentAmount : postNOCDue.totalDue}
                onClose={() => setValue(value - 1)}
              />
            ):( */}
              <Modal
              open={paymentModal}
               onClose={(event, reason) => {
                    if (reason === "backdropClick") return;
                    setValue(value - 1);
                  }}
                disableEscapeKeyDown
              >
              <GatewaySelection
                        onClose={() => setValue(value - 1)}
                        paymentData={buildNOCPaymentData()} 
                        handlePayment={handlePaymentInitiation} 
                        emailForm={!(User?.profile?.personId) && !!id}
                        user={User} 
                        checkTabbyEligibility={checkTabbyEligibility}
                        checkTamaraEligibility={checkTamaraEligibility}


                    /></Modal>
                    
              {/* )} */}
              
            </TabPanel>
          )}
          <TabPanel value={value} index={3}>
            <Thankyou title={General?.codeLabels['cm_out_noc_success_msg']?.label ? General?.codeLabels['cm_out_noc_success_msg']?.label?.replace('{0}', caseId) : ""} msg="" serviceID={serviceId} referenceId={caseId} />
          </TabPanel>
        </Box>
      </ComplaintContainer>
    </div>
  );
};

export default observer(ApplyForNOCInside);
